import { render, staticRenderFns } from "./UpdateTemplateBasic.vue?vue&type=template&id=561f4bad&"
import script from "./UpdateTemplateBasic.vue?vue&type=script&lang=js&"
export * from "./UpdateTemplateBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UpdateTemplateBasic.vue"
export default component.exports